import * as yup from "yup";

declare module "yup" {
   export interface StringSchema {
      /**
       * Check for name validity.
       *       
       * @param {Boolean} [required=false] Is name required.
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      simpleName(
         required: boolean,
         errorMessage?: string
      ): StringSchema;
   }
}
const YUP_NAME_METHOD = "simpleName";
yup.addMethod(yup.string, YUP_NAME_METHOD, function yupSimpleName(
   required: boolean,
   errorMessage: string = ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "Name is required.";

   return this.test(YUP_NAME_METHOD, errMsg, (value: string) => {
      if (!value) {
         return !required;
      }         
      else {
         return /([^\s].+\s?)+/.test(value);
      }         
   });
});
